let GoogleMaps = require('@/mixins/GoogleMaps')

module.exports = {

    mixins: [GoogleMaps],

    data() {
        return {
            autoFocus: true,
            bbox:[
                [ -115.40236340156251, 41.467538547528804],
                [ -124.61989269843751, 32.45428007475598],
            ],
            initLocation: {
                lat: 33.841684,
                lng: -118.3141641
            },
            processing: false,
            searchKey: '',
            cities: [],
            bounds: null,
            markers: [],
        }
    },

    created() {
        App.bus.$on('google-map-loaded', () => {
            this.fetchData()
            this.createSearchHere()
        })
    },

    methods: {
        fetchData() {
            this.processing = true
            axios.post(`/field-audits/candidate-projects/data`, {
                search_key: this.searchKey,
                bbox: this.bbox,
                lat: this.initLocation.lat,
                lng: this.initLocation.lng
            })
                .then(response => {
                    // this.paginator = response.data.paginator;
                    this.cities = response.data.data
                    this.processing = false
                    this.drawMarkers()
                    this.setBboxFilterData()
                })
                .catch(response => {
                    // console.log(response)
                    this.processing = false
                })
        },

        resetSearch() {
            this.autoFocus = true;
            this.initLocation.lat = '';
            this.initLocation.lng = '';
            this.fetchData()
        },

        drawMarkers() {

            this.bounds = null;
            this.bounds = new google.maps.LatLngBounds()

            this.markers.forEach(marker => marker.setMap(null))
            this.markers = [];

            let keys = Object.keys(this.cities)

            for (let i in keys) {
                this.cities[keys[i]].forEach(project => {
                    this.createMarker(project)
                })
            }
            // console.log(this.markers)

            if (this.markers.length && this.autoFocus) {
                this.autoFocus = false
                this.$nextTick(() => this.map.fitBounds(this.bounds))
            }
        },

        createMarker(project) {

            if (project.lat == null || project.lng == null) {
                return
            }

            let routeUrl = `projects/${project.slug}`;

            var marker = new google.maps.Marker({
                id: project.id,
                triggerWhenMouseOver: false,
                position: {
                    lat: project.lat,
                    lng: project.lng,
                },
                zIndex: 200,
                icon: {
                    // url: this.icons[spot.category.slug].icon,
                    scaledSize: new google.maps.Size(25, 29),
                },
                map: this.map,
                info: `<div  class="map-info-window">
                            <div>
                                <a href="${routeUrl}" class="link">
                                    <h6  class="name">${project.name}</h6>
                                </a>
                                <div class="number">${project.number}</div>
                                <a class="address" href="https://www.google.com/maps/place/${project.full_address}" target="_blank">
                                    ${project.full_address}
                                </a>
                                <div class="status">${project.responsible.name}</div>
                                <div>Completed on ${this.shortDate(project.completed_at)}</div>
                            </div>
                        </div>`,
                link: routeUrl
            });

            this.markers.push(marker);

            let self = this;

            google.maps.event.addListener(marker, 'click', function () {
                this.triggerWhenMouseOver = false
                infoWindow.setContent(this.info);
                infoWindow.open(this.map, this);
                self.scrollToProject(this.id)
            });

            var infoWindow = new google.maps.InfoWindow();

            google.maps.event.addListener(marker, 'mouseover', function () {
                this.triggerWhenMouseOver = true
                infoWindow.setContent(this.info);
                infoWindow.open(this.map, this);
            });

            google.maps.event.addListener(marker, 'mouseout', function () {
                if (this.triggerWhenMouseOver) {
                    this.triggerWhenMouseOver = false
                    infoWindow.close(this.map, this);
                }
            });

            this.bounds.extend(marker.position);

            google.maps.event.trigger(this.map, "resize");
        },

        createSearchHere() {

            const controlButton = document.createElement('button');

            // Set CSS for the control.
            controlButton.style.backgroundColor = '#fff';
            controlButton.style.border = '2px solid #fff';
            controlButton.style.borderRadius = '3px';
            controlButton.style.boxShadow = '0 2px 6px rgba(0,0,0,.6)';
            controlButton.style.color = 'rgb(25,25,25)';
            controlButton.style.cursor = 'pointer';
            controlButton.style.fontFamily = 'Roboto,Arial,sans-serif';
            controlButton.style.fontSize = '16px';
            controlButton.style.lineHeight = '38px';
            controlButton.style.margin = '10px 0 22px';
            controlButton.style.padding = '0 5px';
            controlButton.style.textAlign = 'center';

            controlButton.textContent = 'Search This Area';
            controlButton.title = 'Click to search around the center of the map 10miles';
            controlButton.type = 'button';

            // Setup the click event listeners: simply set the map to Chicago.
            controlButton.addEventListener('click', () => {
                this.setBboxFilterData()
                this.fetchData()
            });

            // Create the DIV to hold the control.
            const centerControlDiv = document.createElement('div');

            // Append the control to the DIV.
            centerControlDiv.appendChild(controlButton);

            this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);
        },

        setBboxFilterData(){
            let center = this.map.getCenter();
            this.initLocation.lat = center.lat()
            this.initLocation.lng = center.lng()
            this.bbox = [
                [this.map.getBounds().getNorthEast().lng(), this.map.getBounds().getNorthEast().lat()],
                [this.map.getBounds().getSouthWest().lng(), this.map.getBounds().getSouthWest().lat()]
            ]
        },

        scrollToProject(projectId){
            // let scrollToElement = document.getElementById("project-completed-" + projectId)
            // let scrollTo = $("#project-completed-" + projectId).offset().top;
            // console.log(scrollTo)
            // let element = document.getElementById("list-of-cities")
            // element.scroll({
            //     top: scrollTo,
            //     behavior: "smooth",
            // })
        }
    }
}
